import { PartnerCenterEnrollmentStatus } from "@gamedev-web/one-gaming-crm";

import { SubFormsData } from "../../models/forms";
import { Programs } from "../../models/programsConfig";
import { ProgramsDataResponse } from "../../server/crm/api/models/forms";
import { ProgramsScope } from "../scopes";
import { createOnboardingAction } from "./helpers/actionCreators";

export enum ProgramsActions {
  ADD_PROGRAM_DATA = "@program/ADD_PROGRAM_DATA",
  UPDATE_SUB_FORM = "@program/UPDATE_SUB_FORM",
  UPDATE_PROGRAM_ENROLLMENT_STATUS = "@program/UPDATE_PROGRAM_ENROLLMENT_STATUS",
  RESET = "@program/RESET",
}

export const programsActions = {
  addProgramData: createOnboardingAction(
    ProgramsActions.ADD_PROGRAM_DATA,
    ProgramsScope,
    (program: Programs, programData: ProgramsDataResponse) => ({
      program,
      programData,
    })
  ),
  updateSubFormData: createOnboardingAction(
    ProgramsActions.UPDATE_SUB_FORM,
    ProgramsScope,
    (program: Programs, subFormData: SubFormsData) => ({
      program,
      subFormData,
    })
  ),
  updateProgramEnrollmentStatus: createOnboardingAction(
    ProgramsActions.UPDATE_PROGRAM_ENROLLMENT_STATUS,
    ProgramsScope,
    (program: Programs, enrollmentStatus: PartnerCenterEnrollmentStatus) => ({
      program,
      enrollmentStatus,
    })
  ),
  reset: createOnboardingAction(ProgramsActions.RESET, ProgramsScope, () => ({})),
};
